"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* tslint:disable:no-unused-variable */
var React = require("react");
/* tslint:enable:no-unused-variable */
var Utilities_1 = require("../../Utilities");
var Check_1 = require("../../Check");
var DetailsRowCheckStyles = require("./DetailsRowCheck.scss");
var CheckStylesModule = require("../Check/Check.scss");
// tslint:disable:no-any
var CheckStyles = CheckStylesModule;
exports.DetailsRowCheck = function (props) {
    var canSelect = props.canSelect, isSelected = props.isSelected, anySelected = props.anySelected, selected = props.selected, buttonProps = tslib_1.__rest(props, ["canSelect", "isSelected", "anySelected", "selected"]);
    var isPressed = props.isSelected || props.selected;
    return (React.createElement("button", tslib_1.__assign({}, buttonProps, { role: 'checkbox', className: Utilities_1.css('ms-DetailsRow-check', DetailsRowCheckStyles.check, CheckStyles.checkHost, !props.canSelect && DetailsRowCheckStyles.isDisabled, !props.canSelect && 'ms-DetailsRow-check--isDisabled'), "aria-checked": isPressed, "data-selection-toggle": true, "data-automationid": 'DetailsRowCheck' }),
        React.createElement(Check_1.Check, { checked: isPressed })));
};
//# sourceMappingURL=DetailsRowCheck.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/DetailsList/DetailsRowCheck.js
// module id = 71
// module chunks = 0